<div class="card bg-white">
  <div class="card-body">
    <a routerLink="/forgot-password" class="link">{{
      "authentication.reset-password-hint.back" | translate
    }}</a>
    <p class="text-lg whitespace-pre-line">
      {{ "authentication.reset-password-hint.hint" | translate }}
    </p>
  </div>
</div>
